import React from 'react';

import { BooleanValuesPreview } from '~/components/Shared/Filters_DEPRECATED/ValuesPreview/BooleanValuesPreview';
import { DateValuesPreview } from '~/components/Shared/Filters_DEPRECATED/ValuesPreview/DateValuesPreview';
import { EnumSetValuesPreview } from '~/components/Shared/Filters_DEPRECATED/ValuesPreview/EnumSetValuesPreview';
import { EnumValuesPreview } from '~/components/Shared/Filters_DEPRECATED/ValuesPreview/EnumValuesPreview';
import { FileValuesPreview } from '~/components/Shared/Filters_DEPRECATED/ValuesPreview/FileValuesPreview';
import { NumberValuesPreview } from '~/components/Shared/Filters_DEPRECATED/ValuesPreview/NumberValuesPreview';
import { TextValuesPreview } from '~/components/Shared/Filters_DEPRECATED/ValuesPreview/TextValuesPreview';
import { Field } from '~/evifields/src/types/Field';
import { Filter } from '~/evifields/src/types/Filter';
import {
  ClauseValue,
  DateValue,
  NumberValue,
  TextValue,
} from '~/evifields/src/types/Value';

import ClauseValuesPreview from './ClauseValuesPreview/ClauseValuesPreview';

interface Props {
  field: Field;
  filter: Filter;
}

const ValuesPreview = ({ field, filter }: Props) => {
  switch (field.type) {
    case 'boolean':
      return <BooleanValuesPreview />;
    case 'clause':
      return <ClauseValuesPreview filter={filter as Filter<ClauseValue>} />;
    case 'date':
      return <DateValuesPreview filter={filter as Filter<DateValue>} />;
    case 'enum':
      return (
        <EnumValuesPreview field={field as Field<'enum'>} filter={filter} />
      );
    case 'enum_set':
    case 'folder':
      return (
        <EnumSetValuesPreview
          field={field as Field<'enum_set'>}
          filter={filter}
        />
      );
    case 'file':
      return <FileValuesPreview />;
    case 'number':
      return <NumberValuesPreview filter={filter as Filter<NumberValue>} />;
    case 'text':
    case 'text_search':
    case 'bool_text_search':
      return (
        <TextValuesPreview filter={filter as Filter<TextValue>} field={field} />
      );
    default:
      return null;
  }
};

export default ValuesPreview;
